import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import $ from 'jquery';

import BaseUserList from '../../base/UserList/index'
import UserListItem from '../UserListItem/index'
import UserInfoTooltip from '../UserInfoTooltip/index'

import './styles.scss';

import {openVideoWindow} from '../../../actions/streaming';
import {hideRightSidebar} from '../../../actions/sidebars';

class UserList extends BaseUserList {
    constructor(props) {
        super(props);

        this.state = {
            showUserTooltip: true,
            tooltipUser: false,
            selectedItemNickMobile: undefined
        };

        this.onItemClickMobile = this.onItemClickMobile.bind(this);
        this.onItemMouseMove = this.onItemMouseMove.bind(this);

        this.onContextMenuShown = this.onContextMenuShown.bind(this);
        this.onContextMenuHidden = this.onContextMenuHidden.bind(this);
    }

    onItemClickMobile(user) {
        if (user.nick === this.props.currentUser.nick) {
            return false;
        }

        this.setState({
            selectedItemNickMobile: user.nick !== this.state.selectedItemNickMobile ? user.nick : 'undefined'
        });
    }

    onItemMouseMove(event, user, isWatchingMe, itemComponent) {
        let itemNode = ReactDOM.findDOMNode(itemComponent);
        let itemNodeBoundingClientRect = itemNode.getBoundingClientRect();

        if (!this.state.showUserTooltip) return false;

        if (!this.$popup) {
            this.renderTooltip(user, isWatchingMe);
        }

        var $popup = this.$popup;

        if(!$popup) {
            //TODO: set timeout on the following code to let the popup render
            return false;
        }

        let
            popupWidth = $popup.outerWidth(),
            popupHeight = $popup.outerHeight();

        var target = event.toElement || event.target;
        if (!target) return false;

        let offsetLeft = 16, offsetTop = 16;

        let baseTop = itemNodeBoundingClientRect.top,
            baseLeft = itemNodeBoundingClientRect.left;

        let bottomEdgeReached = baseTop + offsetTop + popupHeight > window.innerHeight;
            //rightEdgeReached = baseLeft + offsetLeft + popupWidth > window.innerWidth;

        let top = bottomEdgeReached ? (window.innerHeight - popupHeight - offsetTop) : (baseTop + offsetTop),
            left = baseLeft - popupWidth + offsetLeft;

        if (event.type === "mouseenter") {
            this.setState({tooltipUser: user});

            this.tooltipPopup.open();

            $popup.css({
                left: left+"px",
                top: top+"px"
            }).removeClass("hidden").addClass("shown");

            return true;
        }

        if (event.type === "mousemove") {
            $popup.data("keep-visible", true);

            $popup.css({
                left: left+"px",
                top: top+"px"
            });

            return true;
        }

        if (event.type === "mouseleave") {
            this.setState({tooltipUser: null});
            
            $popup.data("keep-visible", false);
            window.setTimeout(function() {
                if (!$popup.data("keep-visible")) {
                    $popup.removeClass("shown").addClass("hidden").css({left: "", top: ""});
                }
            }, 50);

            return true;
        }
    }

    renderTooltip(user, watchingMe) {
        const { currentUser } = this.props;

        UserInfoTooltip.mount({
            user,
            watchingMe,
            currentUser,
            ref: (r) => {
                this.tooltipPopup = r;
                this.$popup = $(r._ref)
            }
        });
    }

    onContextMenuShown() {
        this.setState({showUserTooltip: false});
        if (this.tooltipPopup) this.tooltipPopup.close();
    }

    onContextMenuHidden() {
        this.setState({
            showUserTooltip: true,
            selectedItemNickMobile: undefined
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.tooltipUser) this.renderTooltip(nextState.tooltipUser, !!nextProps.watchingMe[nextState.tooltipUser.ufrag]);
    }

    render() {
        let {currentUser, currentRoom, users, watchingMe, videoStreams, browser, openVideoWindow, hideRightSidebar} = this.props;

        let items = users.getItemsSorted();

        let eventRelatedProps = {};
        if (browser.desktop) {
            eventRelatedProps = {
                onMouseEnter: this.onItemMouseMove,
                onMouseMove: this.onItemMouseMove,
                onMouseLeave: this.onItemMouseMove,
            }
        } else if (browser.mobile) {
            eventRelatedProps = {
                onClickMobile: this.onItemClickMobile
            }
        }

        let videoStreamsUids = [];
        for (let streamId in videoStreams) {
            if (!videoStreams[streamId].streamer) continue;
            if (!videoStreams[streamId].stream) continue;
            videoStreamsUids.push(videoStreams[streamId].streamer.uid);
        }

        return (
            <ul id="user-list" className="show-user-info">
                {items.map((user) =>
                    <UserListItem
                        key={user.nick}
                        user={user}
                        currentUser={currentUser}
                        currentRoom={currentRoom}
                        browser={browser}
                        isWatchingMe={!!watchingMe[user.ufrag]}
                        isWatched={videoStreamsUids.indexOf(user.uid) != -1}
                        selectedMobile={this.state.selectedItemNickMobile == user.nick}
                        {...eventRelatedProps}
                        onContextMenuShown={this.onContextMenuShown}
                        onContextMenuHidden={this.onContextMenuHidden}
                        openVideoWindow={openVideoWindow}
                        hideRightSidebar={hideRightSidebar}
                    />
                )}
            </ul>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let roomUsers = [];
    if (state.rooms[ownProps.roomid]) {
        roomUsers = state.rooms[ownProps.roomid].users;
    }

    return {
        currentUser: state.currentUser,
        currentRoom: state.currentRoom,
        users: roomUsers,
        watchingMe: state.watchingMe,
        userSorting: state.userSorting,
        videoStreams: state.videoStreams,
        browser: state.browser
    }
}

let mapDispatchToProps = {
    openVideoWindow,
    hideRightSidebar
};

export default connect(mapStateToProps, mapDispatchToProps)(UserList);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserList/index.js